import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface IdentityVerificationResetDialogData {
  resetsRemaining: number;
}

@Component({
  selector: "app-identity-verification-reset-dialog",
  templateUrl: "./identity-verification-reset-dialog.component.html",
  styleUrls: ["./identity-verification-reset-dialog.component.scss"],
  standalone: false
})
export class IdentityVerificationResetDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<IdentityVerificationResetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IdentityVerificationResetDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  startOver(): void {
    this.dialogRef.close(true);
  }
}
